module.exports = __webpack_public_path__ + "static/media/CROWN-PE-4500-2.cbd69fa9.jpg";